"use client";

import { useEffect, useState } from 'react';
import { GlobalContextProvider } from '@/context/context';
import Menu from '@/components/menu-stuff/Menu';
import { NextIntlClientProvider } from 'next-intl';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { config } from '@fortawesome/fontawesome-svg-core';
import StyledComponentsRegistry from '../lib/registry';
import { Toaster } from 'react-hot-toast';
import LanguageToggle from '@/components/LanguageToggle';
import { BookingsBoxProvider } from '@/context/bookings-box-context';
import getRequestConfig from '../../i18n/request';
import './globals.css';
import { BookingsFunctionalityProvider } from '@/context/bookings-functionality-context';
import { BookingPolicyProvider } from '@/context/booking-policy-context';
import CasinoThemeProvider from '@/components/CasinoThemeProvider';
import ThemeToggle from '@/components/ThemeToggle';
import LogoutBoundary from '@/components/LogoutBoundary';

config.autoAddCss = false;

export default function RootLayoutWrapper({ children, locale }) {
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    (async () => {
      const config = await getRequestConfig({ locale });
      setMessages(config.messages);
    })();
  }, [locale]);

  if (!messages) return null;

  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      <GlobalContextProvider>
      <BookingsBoxProvider>
      <BookingPolicyProvider>
      <BookingsFunctionalityProvider>
        <StyledComponentsRegistry>
        <CasinoThemeProvider>
          <Toaster
            containerStyle={{ zIndex: 100000000000000000 }}
            position="bottom-right"
            toastOptions={{ duration: 5000, style: { border: '1px solid black' } }}
          />
          <LogoutBoundary>
            <Menu />
            <LanguageToggle />
            <ThemeToggle />
            {children}
          </LogoutBoundary>
        </CasinoThemeProvider>
        </StyledComponentsRegistry>
      </BookingsFunctionalityProvider>
      </BookingPolicyProvider>
      </BookingsBoxProvider>
      </GlobalContextProvider>
    </NextIntlClientProvider>
  );
}
